import { render, staticRenderFns } from "./LossReasonSelect.vue?vue&type=template&id=332110cc"
import script from "./LossReasonSelect.vue?vue&type=script&lang=js"
export * from "./LossReasonSelect.vue?vue&type=script&lang=js"
import style0 from "./LossReasonSelect.vue?vue&type=style&index=0&id=332110cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports